module.exports = __webpack_public_path__ + "static/media/puff.41430010.svg";